// Реестр рендеров по типу элемента: рендер есть у КАЖДОГО типа юниона.
// Новый тип добавлять сюда же — гейт исчерпанности внизу файла об этом напомнит.
// Фолбэк-заглушка нужна не для юниона, а для легаси-типов бека (`button`/`divider`/
// `animation`), которые студия не создаёт, но которые лежат в старых данных.
import type { ContentLang } from '@/features/editor/editorSlice'
import type { DesignElement } from '@/types/blocks'
import type { DesignElementWithoutUi } from '@/features/editor/lib/designElements'
import { BadgeElement } from './BadgeElement'
import { HeadingElement } from './HeadingElement'
import { ImageElement } from './ImageElement'
import { TableElement } from './TableElement'
import { TextElement } from './TextElement'
import { UnsupportedElement } from './UnsupportedElement'

export interface DesignElementProps<T extends DesignElement> {
  element: T
  editable: boolean
  contentLang: ContentLang
  onUpdate: (patch: Partial<T>) => void
  onSelect: () => void
  /** Прохождение урока в полноэкранном предпросмотре: элемент рисует то, что
   *  увидит читатель (без авторских заглушек), а не редакторское read-only. */
  isRun?: boolean
}

export const DesignElementView = (props: DesignElementProps<DesignElement>) => {
  const { element } = props
  // Снимаем сырой тип ДО сужения: после исчерпания юниона `element` статически
  // `never`, а в рантайме это легаси-элемент бека, и его тип надо показать автору.
  const rawType: string = element.type
  if (element.type === 'heading') return <HeadingElement {...props} element={element} />
  if (element.type === 'text') return <TextElement {...props} element={element} />
  if (element.type === 'image') return <ImageElement {...props} element={element} />
  if (element.type === 'badge') return <BadgeElement {...props} element={element} />
  if (element.type === 'table') return <TableElement {...props} element={element} />
  // Гейт исчерпанности: сюда обязан доезжать только тип, у которого рендера нет
  // намеренно (сейчас таких нет, `DesignElementWithoutUi` = `never`). Забыли ветку
  // для нового типа юниона — не скомпилируется эта строка.
  const _exhaustive: DesignElementWithoutUi = element
  // Не `null`: невидимый элемент автор не найдёт и не удалит (см. UnsupportedElement).
  // В прохождении — наоборот: заглушку с именем типа ученик видеть не должен.
  return <UnsupportedElement type={rawType} isRun={props.isRun} />
}
